import React from "react";

import classNames from "classnames";
import { Edit, Eye } from "icons";

import { Table, Tooltip } from "clearsense-ui/components";
import { EmptyState } from "components/Common";
import PermissibleWrapper from "components/Common/PermissibleWrapper";

import { NPI_RECORDS_LIST_COLUMNS } from "./constants";

const NPIRecordsList = ({
  npiRecords,
  userPermissions,
  isViewMode,
  searchParams,
  handleEditNPI,
  setIsViewMode,
}) => {
  const checkIfCurrentEditingRecord = record =>
    searchParams?.credentialing_dashboard?.npi === record.npi_number &&
    searchParams?.credentialing_dashboard?.caqh_providerid ===
      record.caqh_providerid &&
    searchParams?.credentialing_dashboard?.rec_create_dt ===
      record.rec_create_dt;

  if (npiRecords.length === 0) {
    return <EmptyState mainText="No Records Found" />;
  }

  return (
    <div>
      <Table
        columnData={[
          ...NPI_RECORDS_LIST_COLUMNS,
          {
            key: "actions",
            width: 50,
            render: (_, record) => (
              <div className="flex space-x-4">
                <PermissibleWrapper
                  currentPermissions={userPermissions}
                  acceptablePermissions="read"
                >
                  <Tooltip position="top" content="View" delay={[800, 0]}>
                    <div>
                      <Eye
                        size={20}
                        className={classNames(
                          "cursor-pointer hover:text-primary-shade",
                          {
                            "text-primary-shade":
                              isViewMode && checkIfCurrentEditingRecord(record),
                          }
                        )}
                        onClick={() => {
                          setIsViewMode(true);
                          handleEditNPI({
                            npi: record.npi_number,
                            rec_create_dt: record.rec_create_dt,
                            subject_id: record.subject_id,
                            caqh_providerid: record.caqh_providerid,
                            evidence_file: record.evidence_file,
                          });
                        }}
                      />
                    </div>
                  </Tooltip>
                </PermissibleWrapper>
                <PermissibleWrapper
                  currentPermissions={userPermissions}
                  acceptablePermissions="update"
                >
                  <Tooltip position="top" content="Edit" delay={[800, 0]}>
                    <div>
                      <Edit
                        size={20}
                        className={classNames(
                          "cursor-pointer hover:text-primary-shade",
                          {
                            "text-primary-shade":
                              !isViewMode &&
                              checkIfCurrentEditingRecord(record),
                          }
                        )}
                        onClick={() => {
                          setIsViewMode(false);
                          handleEditNPI({
                            npi: record.npi_number,
                            rec_create_dt: record.rec_create_dt,
                            subject_id: record.subject_id,
                            caqh_providerid: record.caqh_providerid,
                            evidence_file: record.evidence_file,
                          });
                        }}
                      />
                    </div>
                  </Tooltip>
                </PermissibleWrapper>
              </div>
            ),
          },
        ]}
        rowData={npiRecords}
        allowRowClick={false}
      />
    </div>
  );
};

export default NPIRecordsList;
